module.exports = __webpack_public_path__ + "static/media/reachedTop100_150_180.cea56cfe.png";